/**
 * The visitor's analytics choice, and where it is kept.
 *
 * localStorage rather than a cookie, deliberately: a cookie set to record
 * that someone declined cookies is a bad look, and this value never needs
 * to reach the server.
 */

import { denyAnalyticsConsent, grantAnalyticsConsent, isConfigured } from './gtm';

const KEY = 'alchemiq.campaign.consent';

export function readConsent() {
  try {
    const v = window.localStorage.getItem(KEY);
    return v === 'granted' || v === 'denied' ? v : null;
  } catch {
    // Private mode. Treated as "not yet asked", so the banner shows again
    // rather than silently assuming consent we cannot prove we have.
    return null;
  }
}

export function writeConsent(choice) {
  try {
    window.localStorage.setItem(KEY, choice);
  } catch {
    /* Nothing persisted; the in-page state still applies for this visit. */
  }
}

/**
 * Replays a previously stored `granted` into Consent Mode on load.
 *
 * Without this, someone who accepted last week is measured as denied on
 * every subsequent visit — the stored choice would exist and do nothing.
 */
export function applyStoredConsent() {
  if (!isConfigured()) return null;
  const stored = readConsent();
  if (stored === 'granted') grantAnalyticsConsent();
  else if (stored === 'denied') denyAnalyticsConsent();
  return stored;
}

export function setConsent(choice) {
  writeConsent(choice);
  if (!isConfigured()) return;
  if (choice === 'granted') grantAnalyticsConsent();
  else denyAnalyticsConsent();
}
